export default __webpack_public_path__ + "media/images/logo-5e997913a49e58f7df9f4bc3619a47ec.svg";